var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgContact = function SvgContact(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_contact",
    transform: "translate(-18 -87)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 22,
    height: 22,
    transform: "translate(18 87)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "perm_contact_calendar_FILL0_wght300_GRAD-25_opsz20",
    d: "M178.15-829.17a7.883,7.883,0,0,0-2.778.5,8.909,8.909,0,0,0-2.538,1.477v-.084a.276.276,0,0,0,.069.039.218.218,0,0,0,.077.013H183.3a.184.184,0,0,0,.073-.013.317.317,0,0,0,.064-.039v.1a8.161,8.161,0,0,0-2.492-1.49A7.907,7.907,0,0,0,178.15-829.17Zm-5.81.923a8.578,8.578,0,0,1,2.724-1.489,9.709,9.709,0,0,1,3.086-.5,9.912,9.912,0,0,1,3.087.492,8.193,8.193,0,0,1,2.725,1.5v-10.322a.262.262,0,0,0-.086-.189.262.262,0,0,0-.189-.086H172.614a.262.262,0,0,0-.189.086.262.262,0,0,0-.086.189Zm5.8-3.458a2.79,2.79,0,0,1-2.06-.854,2.83,2.83,0,0,1-.846-2.068,2.79,2.79,0,0,1,.854-2.06,2.83,2.83,0,0,1,2.068-.846,2.79,2.79,0,0,1,2.06.854,2.83,2.83,0,0,1,.846,2.068,2.79,2.79,0,0,1-.854,2.06A2.83,2.83,0,0,1,178.142-831.7Zm.009-1.069a1.774,1.774,0,0,0,1.3-.542,1.78,1.78,0,0,0,.541-1.3,1.774,1.774,0,0,0-.542-1.3,1.78,1.78,0,0,0-1.3-.541,1.774,1.774,0,0,0-1.3.542,1.78,1.78,0,0,0-.541,1.3,1.774,1.774,0,0,0,.542,1.3A1.78,1.78,0,0,0,178.151-832.773Zm-5.54,6.62a1.288,1.288,0,0,1-.942-.4,1.288,1.288,0,0,1-.4-.942V-838.57a1.288,1.288,0,0,1,.4-.942,1.29,1.29,0,0,1,.944-.4h2.037V-841.6a.531.531,0,0,1,.16-.387.524.524,0,0,1,.386-.162.54.54,0,0,1,.391.162.524.524,0,0,1,.165.387v1.693h4.827v-1.71a.514.514,0,0,1,.156-.375.507.507,0,0,1,.374-.158.523.523,0,0,1,.378.158.507.507,0,0,1,.161.375v1.71h2.037a1.283,1.283,0,0,1,.952.4,1.3,1.3,0,0,1,.391.942v11.076a1.3,1.3,0,0,1-.391.942,1.28,1.28,0,0,1-.949.4ZM178.15-834.574Zm.011,7.352h0Z",
    transform: "translate(-149.15 932.153)",
    fill: "#8d8d8d"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact.3ab2d1c2.svg";
export { ForwardRef as ReactComponent };